import React from 'react';
import PropTypes from 'prop-types';
import {
  Container, Title, Description, Footer, RightButton, Content, List, Name, Line, Error,
} from './common/styles';
import Check from './common/check';
import OnboardingContext from './common/context';
import { setInvestorType } from '../../services/onboarding-services';

export default function Investor(props) {
  const { state, dispatch } = React.useContext(OnboardingContext);
  const { nextStep } = props;
  const [invalid, setInvalid] = React.useState(false);

  const onSubmit = e => {
    e && e.preventDefault();
    if (state.selectedInvestorType == null) {
      setInvalid(true);
      return;
    }
    setInvestorType(state.selectedInvestorType).then(() => {
      nextStep();
    });
  };

  const onSelect = investorTypeId => {
    setInvalid(false);
    dispatch({ type: 'setSelectedInvestorType', payload: investorTypeId });
  };

  return (
    <Container>
      <Title>
        What type of investor are you?
      </Title>
      <Description>
        Welcome to Livewire, we’d like to understand what type of
        investor you are so we can better personalise your experience on Livewire.
      </Description>
      <Content>
        <List>
          {state.investorTypes && (state.investorTypes.map(investorType => (
            <Line
              data-role="investor-type"
              key={investorType.id}
              selected={investorType.id === state.selectedInvestorType}
              onClick={() => onSelect(investorType.id)}
            >
              <Check checked={investorType.id === state.selectedInvestorType} />
              <Name>{investorType.name}</Name>
            </Line>
          )))}
        </List>
        {invalid && <Error>Please select which investor type best reflects you.</Error>}
      </Content>
      <Footer>
        <RightButton onClick={onSubmit}>Next</RightButton>
      </Footer>
    </Container>
  );
}

Investor.propTypes = {
  nextStep: PropTypes.func.isRequired,
};
